import {DefaultComponentAnalyticsContext} from '../../../constants/loginDefault';

// List of contexts for the Default component which serve copy from ShopJS instead of Pay.
// These contexts should include the "hide-copy" param to Pay's authorize endpoint.
const CONTEXTS_SERVING_COPY_FROM_SHOP_JS = [
  DefaultComponentAnalyticsContext.Default,
  DefaultComponentAnalyticsContext.CheckoutExtension,
  DefaultComponentAnalyticsContext.CheckoutModal,
  DefaultComponentAnalyticsContext.ClassicCustomerAccounts,
  DefaultComponentAnalyticsContext.PaymentRequest,
];

// List of contexts for the COMPACT Default component which serve copy from ShopJS instead of Pay.
// These contexts should include the "hide-copy" param to Pay's authorize endpoint.
const CONTEXTS_SERVING_COPY_FROM_SHOP_JS_IF_COMPACT = [
  DefaultComponentAnalyticsContext.Default,
  DefaultComponentAnalyticsContext.CheckoutExtension,
  DefaultComponentAnalyticsContext.PaymentRequest,
];

/**
 * Returns whether or not the copy in Pay is hidden for the given context.
 * @param {DefaultComponentAnalyticsContext} context The context of the component, eg. 'loginWithShopSelfServe'.
 * @param {boolean} isCompact is this compact layout or not?
 * @returns {boolean} Whether or not the copy in Pay is hidden for the given context.
 */
export function shouldHidePayCopy(
  context: DefaultComponentAnalyticsContext,
  isCompact = false,
): boolean {
  return isCompact
    ? CONTEXTS_SERVING_COPY_FROM_SHOP_JS_IF_COMPACT.includes(context)
    : CONTEXTS_SERVING_COPY_FROM_SHOP_JS.includes(context);
}
